import { Node, mergeAttributes, wrappingInputRule } from '@tiptap/core';
var inputRegex = /^\s*([-+*])\s$/;
var BulletList = Node.create({
  name: 'bulletList',

  addOptions() {
    return {
      itemTypeName: 'listItem',
      HTMLAttributes: {}
    };
  },

  group: 'block list',

  content() {
    return "".concat(this.options.itemTypeName, "+");
  },

  parseHTML() {
    return [{
      tag: 'ul'
    }];
  },

  renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['ul', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addCommands() {
    var _this = this;

    return {
      toggleBulletList: function toggleBulletList() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.toggleList(_this.name, _this.options.itemTypeName);
        };
      }
    };
  },

  addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-Shift-8': function ModShift8() {
        return _this2.editor.commands.toggleBulletList();
      }
    };
  },

  addInputRules() {
    return [wrappingInputRule({
      find: inputRegex,
      type: this.type
    })];
  }

});
export { BulletList, BulletList as default, inputRegex };